import SliderTab from "./SliderTab";
export default SliderTab;